import { createResourceKeys } from "@/lib/resource-context";

export const mcpGatewaysKeys = createResourceKeys("mcp_gateways");
